import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createUISlice } from './slices/uiSlice'
import { createSessionSlice } from './slices/sessionSlice'
import { createGallerySlice } from './slices/gallerySlice'
import { createChatSlice } from './slices/chatSlice'
import { createAuthSlice } from './slices/authSlice'

export const useAppStore = create(
  persist(
    (...a) => ({
      ...createUISlice(...a),
      ...createSessionSlice(...a),
      ...createGallerySlice(...a),
      ...createChatSlice(...a),
      ...createAuthSlice(...a),
    }),
    {
      name: 'esper-ai-store',
      // partialize: (state) => ({
      //   theme: state.theme,
      //   user: state.user,
      //   isAuthenticated: state.isAuthenticated,
      //   language: state.language
      // })
    }
  )
) 